var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { Tooltip } from "@gravity-ui/uikit";
import { isDesktop } from "@/store/slices/viewportSlice";
export var TooltipWrap = function (props) {
    var isDesktopMode = useSelector(isDesktop);
    return isDesktopMode ? (_jsx(Tooltip, __assign({}, props, { children: props.children }))) : (_jsx(_Fragment, { children: props.children }));
};
